<template>
    <v-container class="pa-2">

  <template>
  <v-card :loading="loading" class="ma-3">
    <v-card-title>
      <h1 class="mr-2 subheading grey--text">Παρτίδα ανταλλακτικού</h1>
      <v-spacer></v-spacer>
       <v-chip label outlined><v-icon>mdi-warehouse</v-icon> {{ order.StockQty}} </v-chip>
       <v-btn icon @click="partInfo"><v-icon>mdi-information</v-icon></v-btn>
      <v-btn icon @click="$router.go(-1)"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols=2 sm=2 md=2>
            <v-text-field
              v-model="order.Id"
              label="Αριθμός Παρτίδας"
              @change="changeOrder"

            ></v-text-field>
          </v-col>
          <v-col cols=12 md=8 sm=8 xs=12>
            <v-textarea
              readonly
              auto-grow
              rows="1"
              :row-height="($vuetify.breakpoint.xs) ? 15 : 10"
              color="black-text"
              v-model="part.Description"
              label="Περιγραφή ανταλλακτικού"
            ></v-textarea>
          </v-col>
           <v-col cols=4 sm=2 md=2 xs=4>
            <v-text-field
              :value="(order.PartNetCost).toFixed(2)"
              label="Κόστος ανταλλακτικού"
              reverse
              readonly
              prefix="€"
            ></v-text-field>
          </v-col>
          <v-col cols=8 md=8 sm=8 xs=12>
            <v-text-field
              v-model="part.Category"
              label="Κατηγορία"
              readonly
            ></v-text-field>
          </v-col>
           <v-col cols=4 sm=2 md=2 xs=4>
            <v-text-field
              :value="order.SuggestedPrice.toFixed(2)"
              label="Sale value"
              reverse
              readonly
              prefix="€"
            ></v-text-field>
          </v-col>
           <v-col cols=4 sm=2 md=2 xs=4>
            <v-text-field
              :value="(order.PartVatCost).toFixed(2)"
              label="ΦΠΑ"
              reverse
              readonly
              prefix="€"
            ></v-text-field>
          </v-col>
          <v-col cols=6 sm=4 md=2>
            <v-text-field
              v-model="part.FmSku"
              label="Κωδικός"
              prepend-icon="mdi-tag"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols=6 sm=4 md=2>
            <v-menu
             v-model="locationMenu"
             :close-on-content-click="false"
             transition="scale-transition"
             offset-y
             min-width="auto"
             >
              <template v-slot:activator="{on, attrs}">
                <v-text-field
                  v-model="order.Location"
                  label="Θέση"
                  append-icon="mdi-map-marker-path"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click="focusBarcodeInput"
                >
                </v-text-field>
              </template>
              <v-card>
                <v-card-text>
                  <v-text-field
                    label="Barcode"
                    @keyup.enter="handleBarcodeEnter"
                    v-model="barcodeInput"
                    dense
                    clearable
                    validate-on="submit-lazy"
                  ></v-text-field>
                  <v-select
                    v-model="locationUnit"
                    :items="['RU', 'SU1', 'SU2', 'SU3', 'CU1', 'CU2', 'OU']"
                    label="Location"
                    dense
                    required
                  ></v-select>
                  <v-autocomplete
                    v-model="locationShelf"
                    :items="shelfPositionOptions"
                    label="Shelf Position"
                    dense
                    :filter="customFilterShelf"
                  ></v-autocomplete>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="secondary" @click="resetLocation">Ακυρωση</v-btn>
                  <v-btn color="primary" @click="updateLocation">Ενημερωση</v-btn>
                </v-card-actions>
              </v-card>
              </v-menu>
          </v-col>
          <v-col cols=6 sm=4 md=2>
            <v-text-field
              v-model="status"
              label="Κατάσταση"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols=12 md=6>
          <v-textarea
            v-if="order.Remarks"
            v-model="order.Remarks"
            prepend-icon="mdi-notebook"
            rows="1"
            :auto-grow=true
            label="Σχόλια"
            hint="Αριθμός πλαισίου, όχημα, κλπ"
            >
         </v-textarea>
          </v-col>
          </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
            <v-dialog
                v-model="dialog"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="!order.StockQty"
                      class="ml-2 white--text">
                      <v-icon>mdi-human-dolly</v-icon>Χρεωση
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Χρέωση</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="checkout">
                    <v-container>
                      <v-row>

                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required, rules.qty]"
                            v-model.number="partQty"
                            required
                            :hint="hintQty"
                            persistent-hint
                            type="number"
                            ></v-text-field>

                      </v-col>
                       <v-col cols="12" sm="8" md=6>
    <v-autocomplete
      v-model="repair"
      :items="repairs"
      cache-items
      hide-no-data
      hide-details
      item-text='Vehicle.PlateNumber'
      return-object
      persistent-hint
      label="Επισκευή"
      :filter="customRepairFilter"

    >
    <template v-slot:selection="data">
                  {{ data.item.Vehicle.PlateNumber }} - {{ data.item.Date }}
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.Vehicle.PlateNumber"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.Vehicle.Owner.Name"></v-list-item-subtitle>
                    <v-list-item-subtitle v-html="data.item.Date"></v-list-item-subtitle>
                    <v-list-item-subtitle v-html="data.item.Id"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>


    </v-autocomplete>
    </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-select
                            label="Τεχνικός"
                            :rules="[rules.required]"
                            v-model="partTechId"
                            :items="technicians"
                            item-text="Name"
                            item-value="Id"
                            dense single-line
                            required
                            ></v-select>
                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialog = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="savePart"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
               <v-dialog
                v-model="dialogReturn"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="!order.StockQty"
                      class="ml-2 white--text">
                      <v-icon>mdi-cube-send</v-icon>Επιστροφή
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Επιστροφή</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="return">
                    <v-container>
                      <v-row>

                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required, rules.qty]"
                            v-model.number="partQty"
                            required
                            :hint="hintQty"
                            persistent-hint
                            type="number"
                            ></v-text-field>

                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogReturn = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="returnPart"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
                <v-dialog
                v-model="dialogSelfUse"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                   <v-btn
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!order.StockQty"
                          class="ml-2 white--text">
                          <v-icon>mdi-basket</v-icon>
                          Ιδιοκαταναλωση
                        </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Ιδιοκατανάλωση</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="selfuse">
                    <v-container>
                      <v-row>

                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required, rules.qty]"
                            v-model.number="partQty"
                            required
                            :hint="hintQty"
                            persistent-hint
                            type="number"
                            ></v-text-field>

                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogSelfUse = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="usePart"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-btn color="primary" :disabled="!order.StockQty" @click="openPrintDialog"><v-icon>mdi-sticker-outline</v-icon> Ετικετα</v-btn>

              <!-- Dialog for printing the label -->

    <PrintDialog
      :item="labelItem"
      :showDialog="showDialog"
      @close="handleDialogClose"
      partOrder=true
    />

    </v-card-actions>
  </v-card>
  <v-card class="ma-3" v-if="order.Invoice">
    <v-card-title>
      <h1 class="mr-2 subheading grey--text">Στοιχεία Παραστατικού</h1>
      <v-spacer></v-spacer>
              <v-btn icon @click="showInvoice"><v-icon>mdi-information</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-container>
          <v-row>
          <v-col cols=4 sm=2 md=2>
          <v-text-field
          label="Κωδικός Τιμολογίου"
          v-model="order.Invoice.Id"
          prepend-icon="mdi-counter"
            >
            <template v-slot:append>
            </template>
          </v-text-field>
          </v-col>

            <v-col cols=4 sm=4 md=2>
          <v-text-field
          label="Σειρά Τιμολογίου"
          v-model="order.Invoice.SeriesCode"
            >
          </v-text-field>
          </v-col>
           <v-col cols=6 sm=4 md=2>
          <v-text-field
          label="Αρ. Τιμολογίου"
          v-model="order.Invoice.DocNumber"
          prepend-icon="mdi-counter"
            >
          </v-text-field>
          </v-col>

          <v-col cols=12 sm=4 md=2>
                <v-text-field
                  v-model="order.Invoice.Date"
                  label="Ημερομηνία"
                  prepend-icon="mdi-calendar"
                  readonly
                ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
         <v-col cols=8 sm=8 md=6>
          <v-text-field
          label="Προμηθευτής"
          v-model="order.Invoice.Supplier.Name">
          </v-text-field>
          </v-col>
          <v-col cols=6 sm=4 md=2>
            <v-text-field
              v-model="order.SupplierSku"
              label="Κωδικός Προμηθευτή"
              readonly
            ></v-text-field>
          </v-col>
           <v-col cols=6 sm=4 md=2>
            <v-text-field
              v-model="order.ManufacturerSku"
              label="Κωδικός Κατασκευαστή"
              readonly
            ></v-text-field>
          </v-col>
              <v-col cols=6 sm=4 md=2>
            <v-text-field
              v-model="order.Manufacturer"
              label="Κατασκευαστής"
              readonly
            ></v-text-field>
          </v-col>
          </v-row>
          <v-row>
          <v-col cols=12 md=12>
          <v-textarea
            v-if="order.Invoice.Remarks"
            v-model="order.Invoice.Remarks"
            prepend-icon="mdi-notebook"
            rows="1"
            :auto-grow=true
            label="Σημειώσεις"
            hint="Αριθμός πλαισίου, όχημα, κλπ"
            >
         </v-textarea>
          </v-col>
          </v-row>
      </v-container>
    </v-card-text>
  </v-card>


   <v-card class="ma-3" v-if="checkouts">
    <v-card-title>
      <h1 class="mr-2 subheading grey--text">Χρεώσεις</h1>
       <v-chip class="ma-2" color="primary" outlined>
        {{ checkoutCount }}
      </v-chip>
      <v-spacer></v-spacer>
      <div class="profit-info">
    <v-chip class="ma-2" color="primary" outlined>
      <v-icon left>mdi-percent</v-icon>
      {{ totalProfitMarginPercentage }}%
    </v-chip>
    <v-chip class="ma-2" color="secondary" outlined>
      <v-icon left>mdi-currency-eur</v-icon>
      {{ $tocurr(totalProfitMargin) }}
    </v-chip>
  </div>
    </v-card-title>
    <v-card-text>
     <v-list two-line>
      <v-list-item-group
        v-model="selected"
        active-class="pink--text"
      >
        <template v-for="(item, index) in checkouts">
          <v-list-item :key="item.Id">
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>

                <v-list-item-subtitle
                  class="text--primary"
                  v-text="`${item.Qty} ${item.RepairItem.Unit} ${item.RepairItem.Description}`"
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  class="text--primary"
                  v-text="`${item.RepairItem.Technician.Name}`"
                ></v-list-item-subtitle>


                <v-list-item-subtitle v-if="!active" v-text="item.Timestamp"></v-list-item-subtitle>
<v-list-item-subtitle v-else v-text="`Περιθώριο Κέρδους ${((item.RepairItem.Price - order.PartNetCost) / item.RepairItem.Price * 100).toFixed(2)}% (${$tocurr(item.RepairItem.Qty * (item.RepairItem.Price - order.PartNetCost))})`"></v-list-item-subtitle>              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text v-text="$tocurr(item.RepairItem.Price)"></v-list-item-action-text>
 <v-btn icon @click="showRepair(item.RepairItem.RepairId)"><v-icon>mdi-information</v-icon></v-btn>

              </v-list-item-action>
            </template>
          </v-list-item>

          <v-divider
            v-if="index < checkouts.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
    </v-card-text>
  </v-card>
   <v-card class="ma-3" v-if="returns">
    <v-card-title>
      <h1 class="mr-2 subheading grey--text">Επιστροφές</h1>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
     <v-list two-line>
      <v-list-item-group>
        <template v-for="(item, index) in returns">
          <v-list-item :key="item.Id">
              <v-list-item-content>
                <v-list-item-title v-text="`Δελτίο Επίστροφης ${item.Id}`"></v-list-item-title>
                <v-list-item-subtitle class="text--primary" v-text="`${item.Qty} ${item.Unit}`"></v-list-item-subtitle>
                <v-list-item-subtitle v-text="item.Shipment.Timestamp"></v-list-item-subtitle>
              </v-list-item-content>

              <!-- Add a button to download the document -->
              <v-btn icon @click="downloadDocument(item.Shipment.Id)" class="ml-auto">
                <v-icon>mdi-file-download</v-icon>
              </v-btn>
          </v-list-item>

          <v-divider
            v-if="index < returns.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
    </v-card-text>
  </v-card>
    </template>
   <v-snackbar
   timeout=2500
   v-model="snackbar">
      {{ snackText }}
  </v-snackbar>
    </v-container>
</template>

<script>
import PrintDialog from  '../../components/PrintLabelDialog.vue'

export default {
  components: {
    PrintDialog,
  },
  data() {
    return {
      expanded: [],
      diaitems: {},
      dialog: false,
      dialogReturn: false,
      dialogSelfUse: false,
      technicians: {},
      order: {StockQty:0},
      partQty: 1,
      partTechId: 1,
      repair: {},
      repairs: [],
      checkouts: [],
      returns: [],
      loading: true,
      balance: 0.0,
      search: '',
      selected: null,
      part: {},
      snackbar: false,
      snackText: '',
      locationShelf: null,
      locationUnit: null,
      autocompleteInput: '',
      shelfPositionOptions: this.generateShelfPositions(),
      locationMenu: false,
      showDialog: false,
      selectedItem: null,
      labelItem: null,
      labelTypes: [],
      rules: {
          required: value => !!value || 'Required.',
          qty: value => value <= this.order.StockQty || 'Out of stock!',

      },
      headers: [
          {
            text: 'Αρ. Παρτίδας',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '5%',
          },
          { text: 'Ημερομηνία', value: 'Invoice.Date', width: '10%' },
          { text: 'Σειρά', value: 'Invoice.SeriesCode' },
        { text: 'Αριθμός Τιμολογίου', value: 'Invoice.DocNumber' },
          { text: 'Κωδικός Προμ.', value: 'SupplierSku' },
          { text: 'Aξία', value: 'PartCost', align: 'end' },
          { text: 'Ποσότητα', value: 'Qty', align: 'end' },
          { text: 'Απόθεμα', value: 'StockQty', align: 'end' },
          { text: 'Τιμή Πώλησης', value: 'SuggestedPrice', align: 'end' },
          { text: 'Actions', value: 'actions' },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async beforeRouteUpdate(to, from, next) {
    // Call the API query method when the URL changes
    const response = await this.$api.get('/inventory/order/info/'+to.params.id);
    if (response.status == 200) {
      this.init(to.params.id)
      next();
    }
    next(false);
  },
  async created() {
    this.init(this.$route.params.id);
    },
watch: {
      timdialog (val) {
        val || this.close()
      },

},
  computed: {
    hintQty () {
      return `Διαθέσιμα: ${this.order.StockQty}`
    },
    status () {
      return this.getStatus(this.order.Status)
    },
    totalProfitMargin() {
      return this.checkouts.reduce((total, item) => {
        return total + (item.RepairItem.Qty * (item.RepairItem.Price - this.order.PartNetCost));
      }, 0);
    },
    checkoutCount() {
        return this.checkouts.reduce((total, item) => total + item.Qty, 0);
    },
    totalProfitMarginPercentage() {
      const totalRevenue = this.checkouts.reduce((total, item) => {
        return total + (item.RepairItem.Qty * item.RepairItem.Price);
      }, 0);
      return totalRevenue ? ((this.totalProfitMargin / totalRevenue) * 100).toFixed(2) : 0;
    },
  },
  methods: {
    async init(orderId) {
      try {
        this.loading = true;
        const response = await this.$api.get('/inventory/order/info/'+orderId);
        // console.log(response);
        this.order = response.data;
        this.part = this.order.PartInfo;
        this.locationUnit = this.order.Location.split('-')[0];
        this.locationShelf = this.order.Location.substr(this.order.Location.indexOf('-') + 1);
        const cats = await this.$api.get('/inventory/parts/category/'+this.part.CategoryId)
        this.part.Category = cats.data.Description;
        const techs = await this.$api.get("/repairs/technicians/");
        this.technicians = techs.data;

        const rep = await this.$api.get("/repairs/?limit=25");
        this.repairs = rep.data;

        const check = await this.$api.get("/inventory/order/checkouts/" +this.order.Id);
        this.checkouts = check.data;

        const rets = await this.$api.get("/inventory/order/returns/" +this.order.Id);
        this.returns = rets.data;

        this.loading = false;
      } catch (error) {
        console.error(error);
      }

    },
    customRepairFilter(item, queryText) {
      // Check for 'rid-<number>', 'RID-<number>', 'ριδ-<number>', or 'ΡΙΔ-<number>' pattern
      const ridMatch = queryText.match(/^(rid|ριδ)-(\d+)$/i);
      if (ridMatch) {
        const id = ridMatch[2];
        // Match by Id (assuming item.Id is a number or string)
        return String(item.Id) === id;
      }
      // Default filter: match by plate number or other fields as needed
      // You can customize this as needed
      const plate = item.Vehicle?.PlateNumber?.toString().toLowerCase() || '';
      const owner = item.Vehicle?.Owner?.Name?.toString().toLowerCase() || '';
      const id = item.Id?.toString().toLowerCase() || '';
      const query = queryText.toLowerCase();
      return (
        plate.includes(query) ||
        owner.includes(query) ||
        id.includes(query)
      );
    },
    changeOrder() {
      if (this.order.Id && this.order.Id !== this.$route.params.id) {
      this.$router.push({name: 'order-info', params: {id: this.order.Id}});
      }
    },
    handleBarcodeEnter() {
      const barcode = this.barcodeInput ? this.barcodeInput.trim() : '';
      this.barcodeInput = null;
      if (barcode) {
        this.locationUnit = barcode.split('-')[0];
        this.locationShelf = barcode.substr(barcode.indexOf('-') + 1);
      }
    },
    resetLocation() {
      this.locationUnit = this.order.Location.split('-')[0];
      this.locationShelf = this.order.Location.substr(this.order.Location.indexOf('-') + 1);
    },
    async updateLocation() {
      const newLocation = `${this.locationUnit}-${this.locationShelf}`;

      if (this.order.Location !== newLocation) {
        this.order.Location = newLocation;
        const response = await this.$api.patch("/inventory/parts/checkin/"+this.order.Id, this.order)
        if (response.status == 202) {
            this.snackText = 'Ενημερώθηκε επιτυχώς';
            this.snackbar = true;
        } else {
            this.snackText = `Προέκυψε σφάλμα κατα την αποστολή. ${response.data.details}`;
            this.snackbar = true;
        }
      }
    },
    generateShelfPositions() {
      const positions = [];
      const sections = ['G', 'R', 'A', 'B', 'C', 'D', 'E'];
      for (let i = 1; i <= 6; i++) {
        for (const section of sections) {
          for (let j = 0; j <= 19; j++) {
            const position = `${i}${section}-${j.toString().padStart(2, '0')}`;
            positions.push(position);
          }
        }
      }
      return positions;
    },
    customFilterShelf(item, queryText, itemText) {
      const query = queryText.toLowerCase().replace(/[^a-z0-9]/gi, '');
      const text = itemText.toLowerCase().replace(/[^a-z0-9]/gi, '');
      if (text.includes(query)) {
        return true;
      }
      const regex = new RegExp(query.split('').join('.*'), 'i');
      return regex.test(text);
    },
    getStatus (status) {
      if (status == -2) return "Χαλασμένο";
      if (status == -1) return "Μεταχειρισμένο";
      if (status == 1) return "Ανακατασκευη";
      if (status == 2) return "Επισκευασμένο";
      if (status == 0) return "Καινούργιο";
    },
  tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
  showInvoice() {
    //console.log(item, this.timdialog)
     let path = "distributor-order-checkin"
    let params = {"invoiceId": this.order.Invoice.Id}
    this.$router.push({"name": path, "params": params});
    //this.diaitems = item.line_items;
    //this.timdialog = true;
  },
   showRepair(item) {
    //console.log(item, this.timdialog)
     let path = "edit-repair"
    let params = {"repairId": item}
    this.$router.push({"name": path, "params": params});
  },
  partInfo() {
        let path = "part-info"
        let params = {"id": this.part.Id}
        this.$router.push({"name": path, "params": params});
  },
  close () {
        this.timdialog = false
  },
  async savePart () {
      let checkout = {
          RepairId: this.repair.Id,
          OrderId: this.order.Id,
          TechId: this.partTechId,
          Qty: this.partQty,
      }
      const resp = await this.$api.post("/inventory/parts/checkout", checkout)
          if (resp.status == 201) {
            alert("Χρεώθηκε")
          try {
            this.loading = true;
            const response = await this.$api.get('/inventory/order/info/'+this.$route.params.id);
            // console.log(response);
            this.order = response.data;
            this.part = this.order.PartInfo;
            const cats = await this.$api.get('/inventory/parts/category/'+this.part.CategoryId)
            this.part.Category = cats.data.Description;

            const check = await this.$api.get("/inventory/order/checkouts/" +this.order.Id);
            this.checkouts = check.data;

            this.loading = false;
          } catch (error) {
            console.error(error);
            }
      }

  },


  async usePart () {
      let checkout = {
          RepairId: 1262,
          OrderId: this.order.Id,
          TechId: 5,
          Qty: this.partQty,
          Price: this.order.PartNetCost,
      }
      const resp = await this.$api.post("/inventory/parts/checkout", checkout)
          if (resp.status == 201) {
            alert("Χρεώθηκε στο μαγαζί")
          try {
            this.loading = true;
            const response = await this.$api.get('/inventory/order/info/'+this.$route.params.id);
            // console.log(response);
            this.order = response.data;
            this.part = this.order.PartInfo;
            const cats = await this.$api.get('/inventory/parts/category/'+this.part.CategoryId)
            this.part.Category = cats.data.Description;
            const techs = await this.$api.get("/repairs/technicians/");
            this.technicians = techs.data;

            const rep = await this.$api.get("/repairs?limit=15");
            this.repairs = rep.data;
            this.loading = false;
          } catch (error) {
            console.error(error);
            }
      }

    },
    async downloadDocument(shipmentId) {
      try {
        // Fetch the token first
        const tokenResponse = await this.$api.get(`/inventory/returns/shipment/${shipmentId}/token`);
        const token = tokenResponse.data;

        // Download the file using the token
      const response = await this.$api.get('/inventory/returns/shipment-pdf',
          { responseType: "blob",
            params: {token: token}
          });
      let url = window['URL'].createObjectURL(response.data)
      var a = document.createElement('a')
      a.href = url
      a.download = `ΔΕΛΤΙΟ ΕΠΙΣΤΡΟΦΗΣ ${shipmentId}.pdf`;
      a.click()
      a.remove()
      setTimeout(() => window.URL.revokeObjectURL(url), 100)
      } catch (error) {
        console.error('Error downloading document:', error);
        // Handle error, show a message to the user, etc.
      }
    },
    async openPrintDialog() {
      this.labelItem = this.order;
      this.showDialog = true;
    },
    handleDialogClose () {
      this.showDialog = false;
      this.labelItem = null;
    },
    async returnPart () {
      let shipment = [this.order.Id]
      const resp = await this.$api.post("/inventory/return-goods", shipment)
          if (resp.status == 201) {
            alert("Επιστράφηκε")
          try {
            this.loading = true;
            const response = await this.$api.get('/inventory/order/info/'+this.$route.params.id);
            // console.log(response);
            this.order = response.data;
            this.part = this.order.PartInfo;
            const cats = await this.$api.get('/inventory/parts/category/'+this.part.CategoryId)
            this.part.Category = cats.data.Description;
            const techs = await this.$api.get("/repairs/technicians/");
            this.technicians = techs.data;

            const rep = await this.$api.get("/repairs?limit=15");
            this.repairs = rep.data;
            this.loading = false;
          } catch (error) {
            console.error(error);
            }
       }
    }
  }
}
</script>
